import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, Fragment as _Fragment, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0bbe58c0"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "Text" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_3 = { class: "Caption" }
const _hoisted_4 = { class: "Text" }
const _hoisted_5 = { class: "Caption" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Image = _resolveComponent("Image")!
  const _component_InlineSVG = _resolveComponent("InlineSVG")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_ctx.image)
      ? (_openBlock(), _createBlock(_component_Image, {
          key: 0,
          image: _ctx.image,
          dimensions: {width: 40, height: 40},
          transformation: 'square_40'
        }, null, 8, ["image"]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("span", null, _toDisplayString(_ctx.fraction.title), 1),
      _hoisted_2,
      _createElementVNode("span", _hoisted_3, _toDisplayString(_ctx.fraction.countText), 1)
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("span", _hoisted_5, _toDisplayString(_ctx.mixWB('TONNES_2')), 1),
      _hoisted_6,
      _createElementVNode("span", null, _toDisplayString(_ctx.fraction.tons.asText), 1)
    ]),
    _createVNode(_component_InlineSVG, {
      class: "Icon",
      src: require('@/assets/svg/angle-right.svg')
    }, null, 8, ["src"])
  ], 64))
}